import React, { useCallback, useEffect } from "react";
import { Form } from "react-bootstrap";
import "./tenantonboard.css";
import { OnboardingForms } from "../../../typings/onboarding";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import { LeaseApplicationReferenceTypesEnum } from "@propertelligent/client-api";
import { useError } from "../../../utils/context/ErrorContext";
import { TextCss } from "../../GlobalCss/TextCss";
import SelectField from "../../../newComponents/form-fields/SelectField";

const StepFour: React.FC<any> = ({
  formData,
  setFormData,
  requiredRange,
  References
}: {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<OnboardingForms>>;
  requiredRange: any,
  References: any

}) => {
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError()
  const setdata = () => {
    if (!References) return;
    setFormData((prevFormData) => ({
      ...prevFormData,
      References:
        prevFormData?.References?.length ? prevFormData?.References
          :
          Array.from({ length: References?.requiredRange }, () => ({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            referenceTypeId: "",
          })),
    }));
  }

  useEffect(() => { setdata() }, [References]);

  const handleContactDetailChange = useCallback((index: number, key: string, value: any) => {
    let sanitizedValue = value;
    if (key === "firstName" || key === "lastName") {
      sanitizedValue = value.replace(/[^a-zA-Z ]/g, "");
    }
    const updatedContactDetails = [...formData];
    updatedContactDetails[index][key] = sanitizedValue;
    setFormData({ ...formData, References: updatedContactDetails });

    const errorKey = `${key}[${index}]`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
  }, [formData]);

  const generateBasicDetails = (index: number) => [
    {
      id: 1,
      name: "firstName",
      labelText: "First Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData[index]?.firstName,
      placeholder: "Enter First Name",
      myClassName: "containerTextField",
      isError: errors[`firstName[${index}]`],
      errorMessages: errorMessages?.[`firstName[${index}]`],
      maxLength: 20,
      minLength:2,
    },
    {
      id: 2,
      name: "lastName",
      labelText: "Last Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData[index]?.lastName,
      placeholder: "Enter Last Name",
      myClassName: "containerTextField",
      isError: errors[`lastName[${index}]`],
      errorMessages: errorMessages?.[`lastName[${index}]`],
      maxLength: 20,
      minLength:2,
    },
    {
      id: 3,
      name: "email",
      labelText: "Email",
      type: FORM_CONTROLFIELD_TYPES.EMAIL,
      value: formData[index]?.email,
      placeholder: "Enter Email Address",
      myClassName: "containerTextField",
      isError: errors[`email[${index}]`],
      errorMessages: errorMessages?.[`email[${index}]`],
    },
    {
      id: 4,
      name: "phoneNumber",
      labelText: "Contact No",
      type: FORM_CONTROLFIELD_TYPES.MOBILE,
      value: formData[index]?.phoneNumber,
      placeholder: "Enter Contact No",
      myClassName: "containerTextField",
      isError: errors[`phoneNumber[${index}]`],
      errorMessages: errorMessages?.[`phoneNumber[${index}]`],
      maxLength: 10,
      inputIndex: index
    },
  ];

  const Radiodata = (index) => [
    {
      id: LeaseApplicationReferenceTypesEnum.CoWorker,
      label: "Co-Worker"
    },
    {
      id: LeaseApplicationReferenceTypesEnum.Landlord,
      label: "Current or Previous Landlord(s)"
    }
  ]

  useEffect(() => {
    clearErrors()
  }, [])

  return (
    <>
      <div className="references-container">

        {formData?.map((items, index) => (
          <div key={index} className="references-row">
            {/* <div className="normal_text black reference-number">{index + 1}</div> */}

            <div className="reference-type">
              <p className={`${TextCss.black.sub_heading_600_14} mb-2`}>Reference Type<span className="red">*</span></p>
              <div className="dropdown-wrapper">
              <Form.Select
                name={`referenceTypeId-${index}`}
                value={items.referenceTypeId !== undefined ? items.referenceTypeId : ""}
                onChange={(e) => handleContactDetailChange(index, "referenceTypeId", Number(e.target.value))}
                className="custom-dropdown"
                style={{ width: "100%", border: errors[`referenceTypeId[${index}]`] ? "1px solid #F05252" : "1px solid #E5E7EB", }}
              ><div>
                <option value="">Select Type</option>
                {Radiodata(index)?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                ))}
                </div>
              </Form.Select>
              </div>
              {errors[`referenceTypeId[${index}]`] &&
                <div style={{ marginTop: "8px" }}>
                  <p className="errorMessageStyles">{errorMessages?.referenceTypeId}</p>
                </div>
              }
            </div>

            {generateBasicDetails(index)?.map((item, i) => (
              <div key={i} className="reference-input">
                <CustomInputs
                  labelText={item.labelText}
                  required={true}
                  name={`${item.name}-${index}`}
                  type={item.type}
                  value={item.value}
                  isFormControl={true}
                  onChange={(e) => handleContactDetailChange(index, item.name, e.target.value)}
                  placeholder={item.placeholder}
                  myClassName={item.myClassName}
                  isError={item.isError}
                  errorMessages={item.errorMessages}
                  maxLength={item.maxLength}
                  maxWidth={'100%'}
                  inputIndex={item.inputIndex}  
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default StepFour;




